import { useStaticData } from '@mc/static-data-react'
import { isLessonTile } from 'libs/utils/outcomes'
import { CourseMeta, Outcome, OutcomeContent } from 'types/data'
import { useOutcomePageEvents } from '../../utils'
import { CourseContentTile } from './CourseContentTile'
import { InstructorInfo } from './InstructorInfo'
import { LessonContentTile } from './LessonContentTile'

interface OutcomeTileProps {
  courseMeta: CourseMeta
  content: OutcomeContent
  isPrioritized?: boolean
}

export const OutcomeTile = ({
  courseMeta,
  content,
  isPrioritized = false,
}: OutcomeTileProps) => {
  const { outcome } = useStaticData<{
    outcome: Outcome
  }>()
  const { trackOutcomeTileClicked } = useOutcomePageEvents()

  return (
    <div>
      {isLessonTile(content) ? (
        <LessonContentTile
          content={content}
          courseMeta={courseMeta}
          isPrioritized={isPrioritized}
          onClick={() =>
            trackOutcomeTileClicked({
              action: 'click_lesson',
              outcomeName: outcome.name,
              category: 'lesson',
              tileClass: courseMeta.courseSlug,
              location: 'outcome_content',
            })
          }
        />
      ) : (
        <CourseContentTile
          content={content}
          courseMeta={courseMeta}
          isPrioritized={isPrioritized}
          onClick={() =>
            trackOutcomeTileClicked({
              action: 'click_trailer',
              outcomeName: outcome.name,
              category: 'class',
              tileClass: courseMeta.courseSlug,
              location: 'outcome_content',
            })
          }
        />
      )}
      <InstructorInfo
        courseMeta={courseMeta}
        onClick={() =>
          trackOutcomeTileClicked({
            action: 'click_class',
            outcomeName: outcome.name,
            category: isLessonTile(content) ? 'lesson' : 'class',
            tileClass: courseMeta.courseSlug,
            location: 'outcome_content',
          })
        }
      />
    </div>
  )
}
